import { render, staticRenderFns } from "./IndustryEdit.vue?vue&type=template&id=1810627d&scoped=true&"
import script from "./IndustryEdit.vue?vue&type=script&lang=js&"
export * from "./IndustryEdit.vue?vue&type=script&lang=js&"
import style0 from "./IndustryEdit.vue?vue&type=style&index=0&id=1810627d&scoped=true&lang=css&"
import style1 from "./IndustryEdit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1810627d",
  null
  
)

export default component.exports